import { useEffect, useState } from "preact/hooks";

interface DebouncedSearchOptions {
  delayMs?: number;
  minLength?: number;
}

function normalizeSearch(value: string, minLength: number): string {
  const q = value.trim();
  return q.length >= minLength ? q : "";
}

export function useDebouncedSearch(
  initialValue = "",
  { delayMs = 350, minLength = 3 }: DebouncedSearchOptions = {},
) {
  const [value, setValue] = useState(initialValue);
  const [query, setQuery] = useState(() => normalizeSearch(initialValue, minLength));

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setQuery(normalizeSearch(value, minLength));
    }, delayMs);

    return () => window.clearTimeout(timeout);
  }, [delayMs, minLength, value]);

  return {
    searchValue: value,
    setSearchValue: setValue,
    debouncedQuery: query,
  };
}
